<template>
  <div>
    <site-header />
    <div class="">
        <div class="px-6 py-2 md:p-6">
          <header class="mb-3">
            <p><strong>Type in a city or location</strong></p>

          </header>
  
          <div class="mb-3">
            <input v-model="listTitleInput" type="text" class="block w-full border border-gray bg-white p-2 mb-2" placeholder="Los Angeles, Kauai, etc">
          </div>
          <div v-if="listTitleInput">
            <button 
              :disabled="loading" 
              class="p-2 text-xs text-white bg-indigo-700 mb-2"
              :class="loading ? 'bg-indigo-100' : ''"
              @click="lookupPlaces">
              {{loading ? 'Creating' : 'Create' }} your list for: <strong>{{listTitleInput}}</strong>{{loading ? '...' : '' }}
            </button>
          </div>
          
          <help-box v-else />
                     
        </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HelpBox from '@/components/HelpBox'
import IdeaCard from '@/components/IdeaCard'
import SiteHeader from '@/components/SiteHeader'
import mongoose from 'mongoose'

export default {
  components: {
    HelpBox,
    IdeaCard,
    SiteHeader
  },
  data () {
    return {
      listTitleInput: null,
      textToParse: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters([
      'list',
    ]),
  },
  methods: {
    ...mapActions([
      'storeList',
    ]),
    parseLine (line) {
      line = line.trim()
      if (!line || line === '') {
        return null
      }
      const possibleCommentDelimeters = ['//', '--', '::', '##']
      let pieces = []
      let name = null
      let comment = null
      let i = 0

      // Search this string to see if one we found one of the delimeters
      while (!comment && i < possibleCommentDelimeters.length) {
        pieces = line.split(possibleCommentDelimeters[i])
        name = pieces.shift().trim()
        if (pieces.length > 0) {
          comment = pieces.join().trim()
        }
        i++
      }

      return {name, comment}
    },
    lookupPlaces () {
      if (!this.listTitleInput) {
        return
      }
      this.loading = true
      // Break up into array of lines
      const parsed = this.parseLine(this.listTitleInput)

      this.storeList({name: parsed.name, description: parsed.comment}).then(() => {
        this.goToList()
      })
    },
    goToList() {
      this.$router.push({ name: 'list', params: { slug: this.list.slug }})
    }
  },
}
</script>



// WEBPACK FOOTER //
// CreatePage.vue?1225834a